//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import showMask from '@/components/mask/mask.vue'
export default {
	data() {
		return {
			detail: {
				memberName: '',
				sex: '',
				phone: '',
				idCard: '',
				email: ''
			},
			show: false,
			animation: false,
			memberId: '',
			actions: [{
					name: '男',
					value: 1
				},
				{
					name: '女',
					value: 0
				}
			]
		}
	},
	watch: {
		show(val) {
			if (!val) {
				setTimeout(() => {
					this.animation = false
				}, 300)
			} else {
				this.animation = true
			}
		}
	},
	components: {
		showMask
	},
	onShow() {
		this.queryData()
	},
	onLoad(event) {
		this.detail.memberName = this.$store.state.userInfo.nickName
		this.memberId = this.$store.state.userInfo.memberId
	},
	methods: {
		queryData() {
			this.$ajax({
				method: 'post',
				url: '/weChat/member/queryById',
				data: {
					memberId: this.memberId
				}
			}).then((res) => {
				this.detail = res.data
				this.detail.sex === 2 || this.detail.sex === '' || this.detail.sex === null ? this.detail.sex = '未知' :
					this.detail.sex === 1 ? this.detail.sex = '男' : this.detail.sex = '女'
			})
		},
		//性别选择
		showSex() {
			this.show = true
		},
		onSelect(item) {
			this.detail.sex = item.name
			this.$ajax({
				method: 'post',
				url: '/weChat/member/updateById',
				data: {
					sex: item.value,
					memberId: this.$store.state.userInfo.memberId
				}
			}).then((res) => {
				this.queryData()
				this.show = false
			})
		},
		onCancel() {
			this.show = false
		},
		changePhone(phone) {
			uni.navigateTo({
				url: phone ? `/pages/personalCenter/myInformation/addPhone?phone=` + phone : '/pages/personalCenter/myInformation/phone'
			})
		},
		//跳转
		handleClick(link) {
			uni.navigateTo({
				url: link
			})
		},
	}
}
